export default {
      count: 0,
      tags: {},
      types: {
            software: {
                  color: '#8A80AA' ,           
                  hide: true,
                  tags: {
                        ERP: {name: 'ERP'},
                        CRM: {name: 'CRM'}
                  }, 
            },
            branche: {
                 color: '#7FA39D' ,           
                 tags:  {}
            },
            category: {
                 color: '#A8808D' ,           
                 tags:  {}
            },
            employee:{
                 color: '#D8A555' ,           
                 tags:  {}
            },
            user: {
                 color: '#9B5D5D',          
                 tags:  {}
            },
            region: {
                 color: '#36455C' , 
                 multiple: true,
                 tags:  {}
            }, 
            question:{
                 color: '#8A80AA',
                 multiple: true,
                 tags:  {}
            }
        },
      selected: []
    }
